export default [
  {
    name: "Emily",
    templates: [
      {
        accounts: [
          {
            account_name: "Owner",
            sub_accounts: [
              {
                breakdown: [
                  {
                    calc_type: "period",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Hire",
                    period: ["2020/10/28 5:50", "2020/12/10 1:48"],
                    value_DAILY_HIRE: "0",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "BB",
                    value_BB: "0",
                  },
                  {
                    calc_type: "percentage",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Add Com",
                    value_PERCENTAGE: "0",
                  },
                  {
                    calc_type: "percentage",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Brokerage",
                    value_PERCENTAGE: "0",
                  },
                ],
                sub_account_name: "Total Hire Pay to Owner",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Hire",
                    value_Days: "42.832",
                    value_Pre_day: "49.315",
                  },
                ],
                sub_account_name: "Cable/Entertaining/Victualling",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "591.770",
                    value_TONS: "57.300",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: "766.510",
                    value_TONS: "59.810",
                  },
                ],
                sub_account_name: "Bunker Delivery",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "364.134",
                    value_TONS: "1115.600",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: "548.432",
                    value_TONS: "153.800",
                  },
                ],
                sub_account_name: "Bunker Redelivery",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "CLUB",
                    value_: "1143.61",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "OCEAN WEATHER ROUTE",
                    value_: "400.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "SURVEY",
                    value_: "450.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Hold cleaning",
                    value_: "3000.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "SURVEY FEE",
                    value_: "1950.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "PDA AT DALIAN FOR BUNKERING V1",
                    value_: "2605.67",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "OFF HIRE",
                    value_: "49639.17",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "OE",
                    value_: "21396.25",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Insurance",
                    value_Days: 0,
                    value_Pre_day: 0,
                  },
                ],
                sub_account_name: "MISC",
              },
            ],
          },
          {
            account_name: "Charterer",
            sub_accounts: [
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "BB",
                    value_BB: "0",
                  },
                  {
                    calc_type: "percentage",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "AddComm",
                    value_: "3.75",
                  },
                  {
                    calc_type: "percentage",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Brokerage",
                    value_: "1.25",
                  },
                  {
                    calc_type: "period",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Hire 1",
                    period: ["2020/10/29 05:06", "2020/12/09 05:06"],
                    value_Daily_Hire: "8400.00",
                  },
                  {
                    calc_type: "period",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Hire 2",
                    period: ["2020/12/09 05:06", "2020/12/10 01:48"],
                    value_Daily_Hire: "11000.00",
                  },
                ],
                sub_account_name: "Total Hire Pay to Owner",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Cable/Entertaining/Victualling",
                    value_Days: "41.863",
                    value_Pre_day: "50",
                  },
                ],
                sub_account_name: "Cable/Entertaining/Victualling",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "350.00",
                    value_TONS: "1049.020",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: "420.00",
                    value_TONS: "157.300",
                  },
                ],
                sub_account_name: "Bunker Remaining....",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "350.00",
                    value_TONS: "1115.600",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: "420.00",
                    value_TONS: "153.800",
                  },
                ],
                sub_account_name: "Bunker Remaining....",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "OFF SURVEY",
                    value_: "300.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Brokerage off hire",
                    value_: "416.06",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Hold cleaning",
                    value_: "5000.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Off hire",
                    value_: "37211.94",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "CTD",
                    value_: "4967.24",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "OE",
                    value_: "21396.25",
                  },
                ],
                sub_account_name: "MISC",
              },
            ],
          },
          {
            account_name: "Administrative",
            sub_accounts: [
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "352.00",
                    value_TONS: "997.000",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: 0,
                    value_TONS: 0,
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: 0,
                    value_TONS: 0,
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: "418.00",
                    value_TONS: "100.000",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: 0,
                    value_TONS: 0,
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "barge fee",
                    value_: 0,
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Additional barge",
                    value_: 0,
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "barge surcharge",
                    value_: 0,
                  },
                ],
                sub_account_name: "Bunker Replenish",
              },
            ],
          },
        ],
        bl: [{ cargo: "FERTILIZER", date: "2024/09/20", quantity: "70000" }],
        charter_type: "TC-TC",
        charterer: "NORVIC",
        creator: 3,
        delivery: "DALIAN",
        disc_port: "",
        lasteditor: 19,
        lastupdate: "2024-09-20 17:58:26",
        laycan: [],
        leg: "V1",
        load_port: "",
        mv: "CELESTIAL BLUE",
        period: [],
        port_stay: [],
        redelivery: "DAHEJ",
        voyage_year: "2020",
      },
      {
        accounts: [
          {
            account_name: "Owner",
            sub_accounts: [
              {
                breakdown: [
                  {
                    calc_type: "period",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Just A Period Hire",
                    period: ["2023/2/27 22:18", "2023/5/7 8:06"],
                    value_DAILY_HIRE: "12025.00",
                  },
                  {
                    calc_type: "percentage",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Add Com",
                    value_PERCENTAGE: "3.75",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "BB",
                    value_BB: "0",
                  },
                  {
                    calc_type: "percentage",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Brokerage",
                    value_PERCENTAGE: "0",
                  },
                ],
                sub_account_name: "Total Hire Pay to Owner",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Cable/Entertaining/Victualling",
                    value_Day: "68.408",
                    value_Pre_day: "50.00",
                  },
                ],
                sub_account_name: "Cable/Entertaining/Victualling",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "771.755",
                    value_TONS: "1085.52",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: "801.114",
                    value_TONS: "196.87",
                  },
                ],
                sub_account_name: "Bunker Remaining on Delivery",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "665.372",
                    value_TONS: "1589.200",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: "801.11801114",
                    value_TONS: "187.170",
                  },
                ],
                sub_account_name: "Bunker Remaining on redelivery",
              },
            ],
          },
          {
            account_name: "Charterer",
            sub_accounts: [
              {
                breakdown: [
                  {
                    bl_date: "2023/03/01",
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "SOYABEAN",
                    value_FREIGHT: "54.70",
                    value_TONS: "71228.670",
                  },
                  {
                    calc_type: "percentage",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Brokerage",
                    value_: "0",
                  },
                  {
                    calc_type: "percentage",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "AddComm",
                    value_: "0",
                  },
                ],
                is_freight: "",
                sub_account_name: "C/P Contract Number...",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "lp demm/des",
                    value_Despatch: "53105.28",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "dp demm/des",
                    value_Despatch: "80626.12",
                  },
                  {
                    calc_type: "percentage",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "addcomm on dem",
                    value_: "0",
                  },
                  {
                    calc_type: "percentage",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "brokerage on dem",
                    value_: "0",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "lp demm/des",
                    value_: "0",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "dp demm/des",
                    value_: "0",
                  },
                ],
                sub_account_name: "Despatch/Demurrage",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Margin",
                    value_: "0",
                  },
                ],
                sub_account_name: "MISC",
              },
            ],
          },
          {
            account_name: "Administrative",
            sub_accounts: [
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "584.500",
                    value_TONS: "1427.950",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "0",
                    value_TONS: "0",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "0",
                    value_TONS: "0",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: "0",
                    value_TONS: "0",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "barge fee",
                    value_: "0",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Additional barge",
                    value_: "0",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "barge surcharge",
                    value_: "0",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "barge",
                    value_: "0",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: "0",
                    value_TONS: "0",
                  },
                ],
                sub_account_name: "Bunker Replenish",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "L.PDA",
                    value: "30684.47",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "TOWAGE SERVIECE",
                    value: "15000.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "D.PDA",
                    value: "47253.47",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "PDA IN singapore",
                    value: "7529.26",
                  },
                ],
                sub_account_name: "Port Disbursement",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Hold Cleaning",
                    value: "3500.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Ocean route service",
                    value_: "1100",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Panama Canal PDA ballast",
                    value_: "0",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Insurance",
                    value_Day: "68.4083333",
                    value_Pre_day: "32.40",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "bank charge",
                    value_: "0",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "SPEED UP COST",
                    value_: "0",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Fumigate removal",
                    value_: "2860.00",
                  },
                ],
                sub_account_name: "MISC",
              },
            ],
          },
        ],
        bl: [],
        charter_type: "TC-VC",
        charterer: "CUTRALE",
        creator: 3,
        delivery: "",
        disc_port: "LONGKOU",
        lasteditor: 19,
        lastupdate: "2024-09-23 17:27:37",
        laycan: [],
        leg: "V11",
        load_port: "SANTOS",
        mv: "PHENOMENAL DIVA",
        period: [],
        port_stay: [],
        redelivery: "",
        voyage_year: "2023",
      },
    ],
  },
  {
    name: "Paul",
    templates: [
      {
        accounts: [
          {
            account_name: "Owner",
            sub_accounts: [
              {
                breakdown: [
                  {
                    calc_type: "period",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Just A Period Hire",
                    period: ["2024/05/01 12:24:00", "2024/07/31 08:54:00"],
                    value_DAILY_HIRE: "18500",
                  },
                  {
                    calc_type: "percentage",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Add Com",
                    value_PERCENTAGE: "3.75",
                  },
                ],
                sub_account_name: "Total Hire Pay to Owner",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "620.00",
                    value_TONS: "1414.640",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: "740.00",
                    value_TONS: "274.440",
                  },
                ],
                sub_account_name: "Bunker Delivery",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "620.00",
                    value_TONS: "1385.330",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: "740.00",
                    value_TONS: "270.300",
                  },
                ],
                sub_account_name: "Bunker Redelivery",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "ILOHC",
                    value_ILHOC: "5000",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "B & C off-hire survey charge ",
                    value_: "300",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "B & C off-hire survey charge ",
                    value_: "2168.72",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "BQS",
                    value_: "800.00",
                  },
                ],
                sub_account_name: "MISC",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Cable/Entertaining/Victualling",
                    value_DAYS: "90.854",
                    value_PER_DAY: "50",
                  },
                ],
                sub_account_name: "Cable/Entertaining/Victualling",
              },
            ],
          },
          {
            account_name: "Charterer",
            sub_accounts: [
              {
                breakdown: [
                  {
                    bl_date: "2024/09/06",
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "SOYABEAN",
                    value_FREIGHT: "46.25",
                    value_TONS: "70324.780",
                  },
                ],
                is_freight: "",
                sub_account_name: "COMERGE / HK NR - VC SOYABEAN20240517",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Dem/des at loadport",
                    value_Despatch: "90073.65",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Dem/des at disport",
                    value_Despatch: "63834.08",
                  },
                ],
                sub_account_name: "Despatch/Demurrage",
              },
            ],
          },
          {
            account_name: "Administrative",
            sub_accounts: [
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "IFO/SANTOS",
                    value_PRICE: "601.00",
                    value_TONS: "499.636",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "IFO/SINGAPORE",
                    value_PRICE: "637.00",
                    value_TONS: "999.291",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "LSMGO/TIANJIN",
                    value_PRICE: "631.00",
                    value_TONS: "327.000",
                  },
                ],
                sub_account_name: "Bunker Replenish",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "SANTOS",
                    value: "32883.15",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "SINGAPORE",
                    value_: "6000.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "TIANJIN",
                    value_: "50000.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "TUG HIRE",
                    value_: "9500",
                  },
                ],
                sub_account_name: "Port Disbursement",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Weather routing service ",
                    value: "2060",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Insurance",
                    value_: "5000",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Bank Charge",
                    value_: 0,
                  },
                ],
                sub_account_name: "MISC",
              },
            ],
          },
        ],
        bl: [],
        charter_type: "TC-VC",
        charterer: "CND",
        creator: 6,
        delivery: "SINGAPORE",
        disc_port: "TIANJIN",
        lasteditor: 19,
        lastupdate: "2024-09-19 10:36:45",
        laycan: [],
        leg: "V1",
        load_port: "SANTOS",
        mv: "ANNA G.",
        period: [],
        port_stay: [],
        redelivery: "TIANJIN",
        voyage_year: "2024",
      },
      {
        accounts: [
          {
            account_name: "Owner",
            sub_accounts: [
              {
                breakdown: [
                  {
                    calc_type: "period",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Hire",
                    period: ["2020/04/04 01:48:00", "2020/04/19 01:48:00"],
                    value_DAILY_HIRE: "6667.14",
                  },
                  {
                    calc_type: "period",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Hire",
                    period: ["2020/04/19 01:48:00", "2020/05/04 01:48:00"],
                    value_DAILY_HIRE: "6054.23",
                  },
                  {
                    calc_type: "period",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Hire",
                    period: ["2020/05/04 01:48:00", "2020/05/19 01:48:00"],
                    value_: "5018.73",
                  },
                  {
                    calc_type: "period",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Hire",
                    period: ["2020/05/19 01:48:00", "2020/06/03 01:48:00"],
                    value_: "5389.80",
                  },
                  {
                    calc_type: "period",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Hire",
                    period: ["2020/06/03 01:48:00", "2020/06/18 01:48:00"],
                    value_: "7056.94",
                  },
                  {
                    calc_type: "period",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Hire",
                    period: ["2020/06/18 01:48:00", "2020/07/03 01:48:00"],
                    value_: "10827.36",
                  },
                  {
                    calc_type: "period",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Hire",
                    period: ["2020/07/03 01:48:00", "2020/07/11 09:30:00"],
                    value_: "13682.47",
                  },
                  {
                    calc_type: "percentage",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Add comm",
                    value_Percentage: "3.75",
                  },
                ],
                sub_account_name: "Total Hire Pay to Owner",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Cable/Entertaining/Victualling",
                    value_DAYS: "50",
                    value_PER_DAY: "98.321",
                  },
                ],
                sub_account_name: "Cable/Entertaining/Victualling",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "300.00",
                    value_TONS: "1048.640",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: "350.00",
                    value_TONS: "375.860",
                  },
                ],
                sub_account_name: "Bunker Remain on board on delivery",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "210.00",
                    value_TONS: "233.393",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "344.00",
                    value_TONS: "1488.217",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "LSMGO",
                    value_PRICE: "350.00",
                    value_TONS: "274.250",
                  },
                ],
                sub_account_name: "Bunker Remain on board on redelivery",
              },
              {
                breakdown: [
                  {
                    calc_type: "period",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Just A OFF Hire",
                    period: ["2020/06/19 16:42:00", "2020/06/25 21:18:00"],
                    value_DAILY_HIRE: "0",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Cable/Entertaining/Victualling",
                    value_DAILY_RATE: "0",
                    value_DAYS: "0",
                  },
                ],
                sub_account_name: "Off Hire",
              },
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "VLSFO",
                    value_PRICE: "0",
                    value_TONS: "0",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "HSFO",
                    value_PRICE: "0",
                    value_TONS: "6",
                  },
                ],
                sub_account_name: "Bunker Consumption During Offhire",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "ILOHC",
                    value_ILHOC: "4200",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Bunker on-hire survey charge",
                    value_BUNKER_ON_HIRE_SURVEY_CHARGE: "492.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "B & C off-hire survey charge ",
                    value_B_C_OFF_HIRE_SURVEY_CHARGE: "0",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "chemical and kits O/E",
                    value_: "15000.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "O/E at Houston",
                    value_: "279.18",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "chemical and kits",
                    value_: "32582.35",
                  },
                ],
                sub_account_name: "MISC",
              },
            ],
          },
          {
            account_name: "Charterer",
            sub_accounts: [
              {
                breakdown: [
                  {
                    bl_date: "2024/09/06",
                    calc_type: "two",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "SORGHUM",
                    value_FREIGHT: "44.50",
                    value_TONS: "60195.382",
                  },
                ],
                is_freight: "",
                sub_account_name:
                  "COMERGE  /CND- VC DD: SORGHUM20200417\t\t\t\t\t\t\t\t",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Dem Due in Loading port",
                    value_Despatch: "13739.06",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "debit",
                    is_settled: false,
                    item_name: "Dem Due in discharge port",
                    value_Despatch: "33342.72",
                  },
                ],
                sub_account_name: "Despatch/Demurrage",
              },
            ],
          },
          {
            account_name: "Administrative",
            sub_accounts: [
              {
                breakdown: [
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "HOUSTON/VLSFO",
                    value_PRICE: "266.00",
                    value_TONS: "1000.010",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "BARGE",
                    value_: "11798.60",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "HARBOR FEE",
                    value_: "32.00",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "HOUSTON/VLSFO",
                    value_PRICE: "210.00",
                    value_TONS: "428.170",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "FUEL SURCHARGE",
                    value_: "2283.6",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "BARGE",
                    value_: "9515.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "HARBOR FEE",
                    value_: "32.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "PORT CHARGES",
                    value_: "10.50",
                  },
                  {
                    calc_type: "two",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "SINGAPORE/VLSFO",
                    value_PRICE: "344.00",
                    value_TONS: "1488.217",
                  },
                ],
                sub_account_name: "Bunker Replenish",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "PANAMA BALLAST",
                    value: "213620.77",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "HOUSTON",
                    value: "242732.12",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "SINGAPORE",
                    value: "1944.38",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "HUANGPU",
                    value: "46760.00",
                  },
                ],
                sub_account_name: "Port Disbursement",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Weather routing service ",
                    value: "1300.00",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "Weather routing service ",
                    value_: "1450.00",
                  },
                ],
                sub_account_name: "MISC",
              },
              {
                breakdown: [
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "P&I to Hull",
                    value: "4500",
                  },
                  {
                    calc_type: "one",
                    debit_credit: "credit",
                    is_settled: false,
                    item_name: "FDD",
                    value: "0",
                  },
                ],
                sub_account_name: "Insurance",
              },
            ],
          },
        ],
        bl: [],
        charter_type: "TC-VC",
        charterer: "CND",
        creator: 6,
        delivery: "Onahama",
        disc_port: "HUANGPU",
        lasteditor: 1,
        lastupdate: "2024-09-13 14:59:41",
        laycan: [],
        leg: "V1",
        load_port: "HOUSTON",
        mv: "LAKE DAWN",
        period: [],
        port_stay: [],
        redelivery: "Huangpu",
        voyage_year: "2020",
      },
    ],
  },
];
